import { Injectable, NgZone, Inject, LOCALE_ID } from '@angular/core';
import { Subject } from 'rxjs';
import { Annyang } from 'annyang';
import { SPEECH_RECOGNITION } from '../../tokens';

declare let annyang: Annyang;

@Injectable({ providedIn: 'root' })
export class SpeechService {
  words$ = new Subject<string>();
  errors$ = new Subject<{ [key: string]: any }>();
  listening = false;

  constructor(
    private zone: NgZone,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(SPEECH_RECOGNITION) isSpeechAvailble: boolean
  ) {
    if (isSpeechAvailble && this.speechSupported) {
      this.init();
    }
  }

  get speechSupported(): boolean {
    return annyang !== undefined;
  }

  init() {
    // const commands = {
    //   'noun :noun': noun => {
    //     this.zone.run(() => {
    //       this.words$.next({ type: 'noun', word: noun });
    //     });
    //   },
    //   'verb :verb': verb => {
    //     this.zone.run(() => {
    //       this.words$.next({ type: 'verb', word: verb });
    //     });
    //   },
    //   'adjective :adj': adj => {
    //     this.zone.run(() => {
    //       this.words$.next({ type: 'adj', word: adj });
    //     });
    //   }
    // };

    // annyang.addCommands(commands);
    annyang.setLanguage(this.locale);
    // Log anything the user says and what speech recognition thinks it might be
    annyang.addCallback(
      'result',
      (userSaid?: string, commandText?: string, results?: string[]) => {
        if (userSaid) {
          this.words$.next(userSaid[0]);
          this.abort();
        }
      }
    );
    annyang.addCallback('errorNetwork', (err: any) => {
      this._handleError('network', 'A network error occurred.', err);
    });
    annyang.addCallback('errorPermissionBlocked', (err: any) => {
      this._handleError(
        'blocked',
        'Browser blocked microphone permissions.',
        err
      );
    });
    annyang.addCallback('errorPermissionDenied', (err: any) => {
      this._handleError('denied', 'User denied microphone permissions.', err);
    });
    // annyang.addCallback('resultNoMatch', userSaid => {
    //   this._handleError(
    //     'no match',
    //     'Spoken command not recognized. Say "noun [word]", "verb [word]", OR "adjective [word]".',
    //     { results: userSaid }
    //   );
    // });
  }

  private _handleError(error: string, msg: string, errObj: any) {
    this.zone.run(() => {
      this.errors$.next({
        error,
        message: msg,
        obj: errObj
      });
    });
  }

  startListening() {
    annyang.start();
    this.listening = true;
  }

  abort() {
    annyang.abort();
    this.listening = false;
  }
}
